import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '../hooks/useMediaQuery';
import './base.css';
import './acumin.css';
import Container from './container';
import Navigation from './navigation';
import NavigationMobile from './navigationMobile';
import Header from './header';

const Layout = (props) => {
  const { children, location } = props;
  const isMobile = useMediaQuery('(max-width:480px)');
  return (
    <Container>
      <Header />
      {!isMobile && <hr className="hr" style={{ marginBlockStart: '2vh', marginBlockEnd: '2vh' }} />}
      {isMobile ? <NavigationMobile /> : <Navigation location={location} />}
      {children}
    </Container>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object,
};

Layout.defaultProps = {
  location: {},
};

export default Layout;
